import React from 'react';
import styles from './EmptyError.module.css';
import printRules from "../PrintRules/style.module.scss";

import IcSearch from '../../components/Svg/IcSearch';

const EmptyError = ({ msg, className, justText, ...props }) => (
  <div className={`${styles.EmptyError} ${className ? className : ''} ${printRules.hide_on_print}`} {...props}>
    <span>
      <div className={styles.icon}>
        <IcSearch />
      </div>
      <p>{msg}</p>
    </span>
  </div>
)

export default EmptyError 